export type GuardAction = 'PUSH' | 'REPLACE' | 'POP';

export interface GuardTarget {
  pathname: string;
  search?: string;
  hash?: string;
}

export interface NavigationGuard {
  shouldBlock(target: GuardTarget, action: GuardAction): boolean;
}

export interface NavigationGuardRegistry {
  register(guard: NavigationGuard): () => void;
  wouldBlock(target: GuardTarget, action: GuardAction): boolean;
  runBypassed(navigate: () => void): void;
  consumeBypass(): boolean;
}

export const createNavigationGuardRegistry = (): NavigationGuardRegistry => {
  const entries = new Set<{ guard: NavigationGuard }>();
  let armed = false;

  return {
    register(guard) {
      const entry = { guard };
      entries.add(entry);
      return () => {
        entries.delete(entry);
      };
    },

    wouldBlock(target, action) {
      for (const { guard } of Array.from(entries)) {
        if (guard.shouldBlock(target, action)) {
          return true;
        }
      }
      return false;
    },

    runBypassed(navigate) {
      armed = true;
      try {
        navigate();
      } finally {
        armed = false;
      }
    },

    consumeBypass() {
      if (!armed) {
        return false;
      }
      armed = false;
      return true;
    },
  };
};

export const navigationGuardRegistry = createNavigationGuardRegistry();
